import React from 'react';
import clsx from '@strava/ui/clsx';

import styles from './OrDivider.module.scss';
import { ThemeTypes } from '..';

interface OrDividerProps {
  text: string;
  theme?: ThemeTypes;
  className?: string;
}

export const OrDivider = ({
  text,
  theme = 'dark',
  className
}: OrDividerProps) => {
  return (
    <div className={clsx(styles.orDivider, className)}>
      <div className={styles.line} />
      <span className={clsx(styles.or, styles[theme])}>{text}</span>
      <div className={styles.line} />
    </div>
  );
};

export default OrDivider;
